import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import Badge from "components/bootstrap/Badge";
import { IfPermitted, Spinner } from "components/common";
import { Row } from "common/components";
import { useModalContext } from "common/contexts";
import { useDetectionChainEvents } from "security-app/hooks/useSecurityEventsAPI";
const DetectionChainRulesHeader = ({ chainName }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const { setModal, setEntity } = useModalContext();
  const { detectionChainEvents, loadingDetectionChainEvents } = useDetectionChainEvents(chainName);
  const openEvidenceModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setEntity(detectionChainEvents.event_ids);
    setModal("ADD-EVIDENCE");
  };
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between" }, /* @__PURE__ */ React.createElement("span", null, t("detection_chain_rules_header.title")), loadingDetectionChainEvents ? /* @__PURE__ */ React.createElement(Spinner, { text: t("detection_chain_rules_header.loading") }) : /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end", $width: "auto", $gap: "md" }, /* @__PURE__ */ React.createElement("small", null, t("detection_chain_rules_header.associated_count"), " ", /* @__PURE__ */ React.createElement(Badge, { bsStyle: "info", bsSize: "sm" }, detectionChainEvents.event_count)), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "investigations:edit" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xs",
      bsStyle: "primary",
      disabled: detectionChainEvents.event_count === 0,
      onClick: openEvidenceModal
    },
    t("detection_chain_rules_header.add_events")
  ))));
};
export default DetectionChainRulesHeader;
